(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7329],{

/***/ 13742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
const Check = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("check", __iconNode);


//# sourceMappingURL=check.js.map


/***/ }),

/***/ 64169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/ai-assistant",
      function () {
        return __webpack_require__(82137);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 24062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13742);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





const EqualDivisionSection = (param)=>{
    let { title , heading , description , checks , image ="" , video ="" , bgColor , imageRight =true , opinion , imageRounded =true , leftDivStyle =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(bgColor, " py-7 md:py-32 transition-all duration-700"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 xl:gap-20 items-start ".concat(leftDivStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(imageRight ? "md:order-1" : "md:order-2", " order-1"),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "uppercase text-purple-900 mb-2 text-xs md:text-base font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "", " text-[28px]  md:text-4xl xl:text-5xl font-semibold text-start ").concat(heading && "mb-6"),
                            children: heading
                        }),
                        description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-900", " mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left"),
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "space-y-4 ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " text-lg md:leading-none xl:leading-relaxed"),
                            children: checks.map((check, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "flex items-start text-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0"
                                        }),
                                        check
                                    ]
                                }, idx))
                        }),
                        opinion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-black", " mb-6  md:text-base w-[70%] pl-4 font-semibold font-medium mt-10 text-start hidden md:block"),
                            children: [
                                opinion,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-BoloSign User"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-color  rounded-2xl relative  ".concat(imageRight ? "order-2" : "order-1"),
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: image,
                            alt: "Contract Creation",
                            width: 500,
                            height: 500,
                            className: "w-full ".concat(imageRounded ? "rounded-2xl" : "")
                        }),
                        video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            src: video,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            className: "w-full h-full object-cover rounded-2xl"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EqualDivisionSection);


/***/ }),

/***/ 28565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);




const ClmShowcaseSection = (param)=>{
    let { heading , desc , showcaseData  } = param;
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [underlineWidth, setUnderlineWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const activeItem = showcaseData[activeIndex];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setUnderlineWidth(0); // Reset underline width
        const duration = activeItem.videoLength * 1000; // duration in ms
        const steps = duration / 100; // update every 100ms
        const increment = 100 / steps;
        let currentWidth = 0;
        const interval = setInterval(()=>{
            currentWidth += increment;
            if (currentWidth >= 100) {
                clearInterval(interval);
                setActiveIndex((prev)=>(prev + 1) % showcaseData.length); // advance to next
            }
            setUnderlineWidth(Math.min(currentWidth, 100));
        }, 100);
        return ()=>clearInterval(interval); // clear interval on unmount or index change
    }, [
        activeIndex
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl leading-snug mx-auto font-semibold w-[850px] max-w-full",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-5 w-[85%] md:w-[50%] mx-auto text-[18px] font-medium max-w-full",
                children: desc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:flex-row md:flex hidden flex-col mt-20 justify-center items-center w-full gap-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 md:w-auto w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col ",
                            children: showcaseData.map((item, idx)=>{
                                const isActive = activeIndex === idx;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: "relative h-[46px] bg-transparent border-t  text-gray-600 flex justify-start items-center gap-4 hover:bg-black/ ".concat(isActive ? "border-gray-900 font-bold" : "border-gray-300"),
                                    onClick: ()=>setActiveIndex(idx),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "rounded-full border border-black flex justify-center items-center w-7 h-7 font-light ".concat(isActive ? "bg-black text-white" : "text-black bg-transparents"),
                                            children: idx + 1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "relative z-10 whitespace-nowrap",
                                            children: item.navText
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "absolute top-0 left-0 h-0.5 bg-dark transition-all ease-linear",
                                            style: {
                                                width: isActive ? "".concat(underlineWidth, "%") : "0%"
                                            }
                                        })
                                    ]
                                }, item.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:w-[490px] md:h-[752px] w-[60%] h-auto md:rounded-[40px] rounded-[20px] border-white border-[10px] overflow-hidden",
                        children: [
                            activeItem.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: activeItem.imgSrc,
                                alt: "video",
                                width: 490,
                                height: 752,
                                className: "w-full h-full object-cover"
                            }),
                            !activeItem.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                className: "w-full h-full object-cover",
                                src: activeItem.videoURL,
                                autoPlay: true,
                                muted: true,
                                loop: true
                            }, activeItem.videoURL)
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-1 text-left",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-2xl md:text-4xl leading-snug mt-2 font-bold",
                                children: activeItem.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-6 text-[18px] leading-[26px] font-medium mb-10",
                                children: activeItem.desc
                            }),
                            activeItem.buttonText && activeItem.buttonClickURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .CLMButtonPrimary */ .IS, {
                                buttonText: activeItem.buttonText,
                                buttonUrl: activeItem.buttonClickURL
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex md:hidden flex-col gap-16 w-full mt-20 ",
                children: showcaseData.map((item, idx)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " w-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 md:w-auto w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: "relative h-[46px] bg-transparent border-t text-gray-600 flex justify-start items-center gap-4 hover:bg-black/5 border-gray-900 font-bold w-full",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "rounded-full border border-black flex justify-center items-center w-7 h-7 font-light bg-black text-white",
                                            children: idx + 1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "relative z-10",
                                            children: item.navText
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: " flex-1 text-left ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-2xl leading-snug mt-2 font-semibold",
                                        children: item.heading
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-6 mb-10",
                                        children: item.desc
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-[60%] h-auto rounded-[20px] border-white border-[10px] overflow-hidden mx-auto",
                                children: [
                                    item.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: item.imgSrc,
                                        alt: "video",
                                        width: 490,
                                        height: 752,
                                        className: "w-full h-full object-cover"
                                    }),
                                    !item.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                        className: "w-full h-full object-cover",
                                        src: item.videoURL,
                                        autoPlay: true,
                                        muted: true,
                                        loop: true
                                    }, item.videoURL)
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full text-center mt-10",
                                children: activeItem.buttonText && activeItem.buttonClickURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .CLMButtonSecondary */ .f6, {
                                    buttonText: item.buttonText,
                                    buttonUrl: item.buttonClickURL
                                })
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClmShowcaseSection);


/***/ }),

/***/ 82137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29937);
/* harmony import */ var components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24062);
/* harmony import */ var components_CLM_ShowCase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28565);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);








const ActiveCard = (param)=>{
    let { title , desc , videoSrc , imgSrc , isImageRight =true , bgColor ="bg-white"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col md:flex-row gap-8 md:gap-12 md:my-12 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:w-1/3 w-full text-start flex flex-col justify-center items-start  ".concat(isImageRight ? "md:order-1" : "md:order-2"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-3xl md:text-4xl font-semibold mb-4 md:mb-8",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-lg font-medium  md:text-xl md:mb-9",
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:w-2/3 w-full ".concat(isImageRight ? "md:order-2" : "md:order-1", " flex-1"),
                children: [
                    videoSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        src: videoSrc,
                        alt: "ai-agent",
                        width: 500,
                        height: 500,
                        className: "rounded-xl w-full",
                        autoPlay: true,
                        loop: true,
                        muted: true
                    }),
                    imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                        src: imgSrc,
                        alt: "ai-agent",
                        width: 500,
                        height: 500,
                        className: "rounded-xl  w-full"
                    })
                ]
            })
        ]
    });
};
const CLMHeroData = {
    // title: "Reporting",
    heading: "Introducing Certius",
    description: "Your AI legal assistant that makes reviewing and drafting contracts feel effortless.",
    // image: `${BASE_ASSETS_URL}/v2/clm/ai-assistant-hero.gif"),
    video: "/videos/ai-assistant-hero.mp4",
    btnText: "Contact Sales",
    btnUrl: "/clm/request-demo"
};
const showcaseData = [
    {
        id: 1,
        navText: "Clause Replacement",
        videoURL: "/videos/ai-assistant-instant.mp4",
        // imgSrc: `${BASE_ASSETS_URL}/v2/clm/ai-assistant-instant.gif"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "One-click clause replacement",
        desc: "One-click suggestions for risky clauses—based on your contract type and playbook.",
        // buttonText: "Explore the platform",
        // buttonClickURL: "/clm/",
        videoLength: 11
    },
    {
        id: 2,
        navText: "Form Autofill",
        videoURL: "/videos/ai-assistant-auto.mp4",
        // imgSrc: `${BASE_ASSETS_URL}/v2/clm/ai-assistant-auto.gif"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "Auto-generate smart intake forms",
        desc: "AI transforms contract fields into dynamic questionnaires, collecting accurate inputs from business teams without legal back-and-forth.",
        // buttonText: "See how it works",
        // buttonClickURL: "/clm/",
        videoLength: 12
    },
    {
        id: 3,
        navText: "Inline Drafting",
        videoURL: "/videos/ai-assistant-inline.mp4",
        // imgSrc: `${BASE_ASSETS_URL}/v2/clm/ai-assistant-inline.gif"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "Inline AI drafting",
        desc: "Work directly in the document editor generate redlines, summaries, or clauses without jumping to a prompt bar.",
        // buttonText: "Learn more",
        // buttonClickURL: "/clm/",
        videoLength: 13
    },
    {
        id: 4,
        navText: "Legal Context",
        videoURL: "/videos/ai-assistant-legal.mp4",
        // imgSrc: `${BASE_ASSETS_URL}/v2/clm/ai-assistant-legal.gif"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "Context-aware legal AI",
        desc: "AI trained on legal language, clause types, and context—so it gets what “termination for convenience” actually means.AI trained on real legal context, from indemnities to terminations—so it understands what your contracts are really saying",
        // buttonText: "Discover now",
        // buttonClickURL: "/clm/",
        videoLength: 11
    }
];
const AIAssistent = (param)=>{
    let { isDarkMode , setIsDarkMode  } = param;
    const sectionRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const section = sectionRef.current;
        if (!section) return;
        const handleScroll = ()=>{
            const rect = section.getBoundingClientRect();
            const topTrigger = 120; // or some margin like 100
            const bottomTrigger = window.innerHeight;
            const isInView = rect.top <= topTrigger && rect.bottom >= bottomTrigger / 2;
            setIsDarkMode(isInView);
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll(); // Initial check
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Certius AI Assistant for Contract Management | BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "BoloSign is an AI-powered contract management platform to draft, review, automate, and eSign contracts faster with built-in CLM."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "AI contract assistant, contract management AI, AI-powered CLM, contract drafting AI, contract review AI, legal AI assistant, AI contract automation, smart contract management, AI for legal teams, contract analysis AI"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/ai-assistant/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title="Templates"
                heading: "Extract contract data instantly with AI",
                description: "Certius instantly pulls out the key data from every contract, like names, values, dates, and clauses. So you don’t have to dig through pages ever again.",
                // image={`${BASE_ASSETS_URL}/v2/clm/ai-assistant-extract.gif")}
                video: "/videos/ai-assistant-extract.mp4",
                bgColor: "bg-transparent",
                imageRight: false,
                checks: [
                    "No manual tagging or data entry.",
                    "Auto-detects 100+ metadata points instantly.",
                    "Filter, track, and report on any clause or field.",
                    "Manage metadata at scale across teams and contracts."
                ],
                leftDivStyle: "items-center md:-mt-20 md:-mb-32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-[#f4f2f0]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-screen-xl md:px-8 px-4 mx-auto py-20 text-gray-900 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_ShowCase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        heading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                "Let Certius do the legal heavy ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " lifting for You"
                            ]
                        }),
                        desc: "AI features built to help legal teams move faster, reduce errors, and free up time for strategic work.",
                        showcaseData: showcaseData
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "transition-colors duration-300  ".concat(isDarkMode ? "bg-dark text-white" : "bg-white text-black"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    ref: sectionRef,
                    className: "pt-20 ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-screen-xl md:px-8 px-6 mx-auto md:py-16 py-12  text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActiveCard, {
                                imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/ai-assistant-playbook.png"),
                                title: "Review contracts faster and smarter",
                                desc: "Certius helps legal teams cut review time with smart suggestions, instant redlines, and built-in compliance checks.",
                                isImageRight: true,
                                bgColor: ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-screen-xl md:px-8 px-6 mx-auto md:py-16 py-12   text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActiveCard, {
                                imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/ai-assistant-ask-ai.png"),
                                title: "AI document assistant",
                                desc: "Navigate complex documents with our voice-enabled AI assistant. Get plain-English explanations of complicated terms and conditions as you go.",
                                isImageRight: true,
                                bgColor: ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "max-w-screen-xl md:px-8 px-6 mx-auto md:py-16 py-12   text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActiveCard, {
                                imgSrc: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/ai-assistant-improve.png"),
                                title: "Improve your contracts with precise edits & insights",
                                desc: "Certius delivers precise suggestions and contextual improvements based on industry-best language, ensuring your agreements stay clear, compliant, and review-ready.",
                                isImageRight: true,
                                bgColor: ""
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-0 md:px-8 bg-cream",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: " max-w-screen-xl mx-auto px-6 xl:px-8 md:py-32 py-16 text-black md:rounded-2xl flex flex-col md:flex-row justify-between ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mb-6 md:mb-0 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-2xl md:text-4xl xl:text-5xl font-semibold mb-4 xl:mb-8",
                                    children: "Here’s how shine above uses BoloSign CLM"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-feedback.png"),
                                    alt: "Customer discussion",
                                    className: "w-[90%]",
                                    width: 1000,
                                    height: 1000
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full md:w-2/3 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/contract-management-brown.png"),
                                alt: "Customer discussion",
                                className: "w-full",
                                width: 1000,
                                height: 1000
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AIAssistent);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(64169); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);